import { Currency, CurrencyDto, IResponse } from '@/types';
import { createStore, withProps } from '@ngneat/elf';

export interface CurrencyStateProps {
  response: IResponse<Currency>;
  dto: CurrencyDto;
  serverState: Currency | undefined;
  isEqual: boolean;
}

export const currencyInitialState: CurrencyStateProps = {
  response: [],
  dto: {
    code: '',
    description: '',
    taux: 0,
  },
  serverState: undefined,
  isEqual: true,
};

export const currencyStateStore = createStore(
  { name: 'currency-state' },
  withProps<CurrencyStateProps>({
    ...currencyInitialState,
  })
);
